<template>
</template>

<script>
import 'nprogress/nprogress.css';
import NProgress from 'nprogress';

export default {
  name: 'progress-bar',

  mounted() {
    if (this.$store.state.progress.progressing) NProgress.start();
  },

  watch: {
    '$store.state.progress.progressing'(n, o) {
      if (n === true && o === false) NProgress.start();
      else if (n === false && o === true) NProgress.done();
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/ProgressBar.vue